'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["position", "show"];
import React from 'react';
import { screenXsMax } from '@spotify-internal/encore-foundation';
import { ButtonPrimary } from "../../../components/ButtonPrimary/index.mjs";
import { IconChevronLeft } from "../../../components/Icon/icons/IconChevronLeft/index.mjs";
import { IconChevronRight } from "../../../components/Icon/icons/IconChevronRight/index.mjs";
import styled, { css } from "../../../styled-components.mjs";
import { cssControlSize } from "../../layout-theme.mjs";
var ButtonPrimaryContainer = styled.div.withConfig({
  displayName: "OverflowButton__ButtonPrimaryContainer",
  componentId: "sc-e0k2al-0"
})(["", ""], function (_ref) {
  var $position = _ref.$position,
    $show = _ref.$show;
  return css(["position:absolute;display:flex;inset-block-start:0;inset-block-end:0;z-index:1;opacity:1;transition:opacity 0.3s;place-content:center center;min-inline-size:", ";pointer-events:none;> button{pointer-events:auto;}", ";", " @media (max-width:", "){opacity:0;}"], cssControlSize('base', '48px'), $position === 'start' ? css(["inset-inline-start:0;margin-inline-end:calc(-1 * ", ");"], cssControlSize('base', '48px')) : css(["inset-inline-end:0;margin-inline-start:calc(-1 * ", ");"], cssControlSize('base', '48px')), !$show && css(["opacity:0;> button{pointer-events:none;}"]), screenXsMax);
});

/* A11y note: OverflowButton is intentionally not keyboard accessible (via aria-hidden and tabindex=-1) as they are only useful for visual / mouse users */

export var OverflowButton = function OverflowButton(_ref2) {
  var position = _ref2.position,
    show = _ref2.show,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(ButtonPrimaryContainer, {
    $position: position,
    $show: show
  }, /*#__PURE__*/React.createElement(ButtonPrimary, Object.assign({
    "aria-hidden": "true",
    tabIndex: -1,
    iconOnly: position === 'start' ? IconChevronLeft : IconChevronRight,
    size: "small",
    colorSet: "overMedia",
    "data-testid": "overflow-button-".concat(position)
  }, props)));
};